<template>
  <section class="talk-to-us">
    <img class="avatar"
      :src="avatarSrc"
      width="120"
      height="120"
      alt="Physician Portrait"
      title="Physician Portrait"
    />
    <div class="content">
      <h1>{{ title }}</h1>
      <slot name="content" />
      <a
        v-if="!!callToAction"
        :href="callToAction.path"
        class="call-to-action btn btn-primary"
        id="consult_scheduling"
        :target="callToAction.externalLink ? '_blank' : null"
        :data-analytics-path="callToAction.analyticsPath"
        :data-requisition-number="callToAction.requisitionNumber"
        :data-order-id="callToAction.orderId"
      >
        {{ callToAction.text }}
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TalkToUs',
  props: {
    title: {
      type: String,
      default: ''
    },
    avatarSrc: {
      type: String,
      default: ''
    },
    callToAction: {
      type: Object,
      default: null
    },
  }
}
</script>

<style lang="scss">
  .talk-to-us {
    > .content {
      p:last-child {
        margin-bottom: 0
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../../stylesheets/color-theme";
  @import "../../../stylesheets/variables";

  .talk-to-us {
    padding: 1.5rem;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 1.25rem;
    align-items: center;
    font-family: "Proxima Nova";
    background-color: var(--white);
    box-shadow: $box-shadow-sm;
    border-radius: 2px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      text-align: center;
    }

    > .avatar {
      border-radius: 500em;
      border: 2px solid var(--white);
      box-shadow: 0 0 12px 0 rgba($black, 0.2);

      @media screen and (max-width: 768px) {
        margin-right: auto;
        margin-left: auto;
      }
    }

    > .content {
      font-size: .875rem;

      h1 {
        font-size: 1.5rem;
      }
    }
  }

  .call-to-action {
    display: inline-block;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1rem;
    border-radius: 500rem;
    box-shadow: 0 4px 8px 0 rgba($primary, 0.4);
    margin-top: 1rem;
  }
</style>
